import { useParams } from 'react-router-dom'
import { ComponentState, useComponentStateMachine } from '../../shared/hooks/useComponentStateMachine'
import { useRepositoriesContext } from '../../../contexts/RepositoriesContext'
import LoadingElement from '../../components/loading-element/loading-element'
import { ErrorView } from '../../components/error-view/ErrorView'
import { useOrganizationDetailsViewCustomer } from './useOrganizationDetailsViewVendor'
import { OrganizationDetailsView } from '../../components/Organization/organization-details-view.component'

export function CustomerDetailsScreen() {
  const params = useParams()
  const id = params?.customerId
  return <OrganizationDetailsScreen organizationId={+id!} />
}

export function VendorDetailsScreen() {
  const params = useParams()
  const id = params?.vendorId
  return <OrganizationDetailsScreen organizationId={+id!} />
}

interface Props { organizationId: number }

function OrganizationDetailsScreen({ organizationId }: Props) {

  const { state, dataTransition } = useComponentStateMachine()
  const { organizationRepository } = useRepositoriesContext()
  const {
    data: customer,
    isError: isCustomerError,
    isLoading: isCustomerLoading,
    isSuccess: isCustomerSuccess
  } = organizationRepository.useCustomer(organizationId)

  const vm = useOrganizationDetailsViewCustomer(customer!)

  const isLoading = isCustomerLoading
  const isSuccess = isCustomerSuccess
  const isError = isCustomerError

  dataTransition(isLoading, isSuccess, isError)

  return state === ComponentState.Succeed
    ? <OrganizationDetailsView {...vm} organization={customer!} />
    : state === ComponentState.Loading
      ? <div className={'h-128 relative'}>
        <LoadingElement />
      </div>
      : <div className={'w-220 h-128 relative'}>
        <ErrorView />
      </div>
}

